<template>
<div class="chapter">
<div class="inner_page">
<section>
<figure><div class="image"><img alt="image" src="images/pgvi.png"/></div></figure>
<p class="noindentt"><span epub:type="pagebreak" id="page_vi" title="vi">The icon above says you’re holding a book in the Felony &amp; Mayhem “British” category. These books are set in or around the UK, and feature the highly literate, often witty prose that fans of British mystery demand. If you enjoy this book, you may well like other “British” titles from Felony &amp; Mayhem Press.</span></p>
<figure><div class="image2"><img alt="image" src="images/comm.png"/></div></figure>
<p class="noindentt">For information about British titles or to learn more about Felony &amp; Mayhem Press, please visit us online at:</p>
<p class="center"><a href="http://www.FelonyAndMayhem.com" target="_blank">www.FelonyAndMayhem.com</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Fm02.vue?7b81f73b